import AnswerSubQuestionConnectionAnswer from './AnswerSubQuestionConnectionAnswer';

export default AnswerSubQuestionConnectionAnswer;
